import { render, staticRenderFns } from "./remoteSeaBookingBasic.vue?vue&type=template&id=20df356e&scoped=true&"
import script from "./remoteSeaBookingBasic.vue?vue&type=script&lang=js&"
export * from "./remoteSeaBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./remoteSeaBookingBasic.vue?vue&type=style&index=0&id=20df356e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df356e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20df356e')) {
      api.createRecord('20df356e', component.options)
    } else {
      api.reload('20df356e', component.options)
    }
    module.hot.accept("./remoteSeaBookingBasic.vue?vue&type=template&id=20df356e&scoped=true&", function () {
      api.rerender('20df356e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/remoteSeaBookingBasic.vue"
export default component.exports